import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Invoices.css';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import SearchBar from 'components/shared/navigation/SearchBar';
import { getTabSelection } from 'selectors/admin/invoices/invoices';
import { tabSelectionChange } from 'actions/admin/invoices/invoices';
import InvoicesTable from './InvoicesTable';
import DepositsTable from './DepositsTable';

class Invoices extends Component {
  render() {
    return (
      <div className="invoices">
        <div className="full-title">Invoices / Deposits</div>
        <div className="content-container">
          <SearchBar>
            <NavigationBar
              items={[
                {
                  id: 1,
                  title: 'Invoices',
                },
                {
                  id: 2,
                  title: 'Deposits',
                },
              ]}
              onSelected={this.handleNavSelect}
            />
          </SearchBar>

          {this.props.tabSelection === 1 && <InvoicesTable />}
          {this.props.tabSelection === 2 && <DepositsTable />}
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.props.dispatch(tabSelectionChange(1));
  }

  handleNavSelect = (id) => {
    this.props.dispatch(tabSelectionChange(id));
  };
}

export default connect((state) => {
  return {
    tabSelection: getTabSelection(state),
  };
})(Invoices);



// WEBPACK FOOTER //
// ./src/components/admin/invoices/Invoices.js